import { createCRUDHook } from './createCRUDHook';
import { LeadDto } from 'utils/models';
import { CRM_LEAD } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<LeadDto>({
  entityName: 'Lead',
  endpoint: CRM_LEAD,
});

export const LeadContext = Context;
export const useLeadManager = useManager;
export const useLead = useConsumer;
